import React from 'react';

export default class Cell extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            status: true,
        };
        this.reactClick = this.reactClick.bind(this);
    }

    reactClick() {
        if(!this.props.refPC[this.props.ind]){
        this.props.onClick();
        this.setState(state => ({
            status: !state.status
        }));

        console.log(this.state.status);
    }
    }

    render() {

        //Estilos de click
        var noclick = {
            color:'black',
            background: 'aliceblue'
        };

        var clicked = {
            color:'white',
            background: '#4d4d4dff'
        };

        var acertou ={
            color:'black',
            background: '#FFD286'
            
        }


        return (
            <div className='button-board'>
            <button
                style={this.state.status ? this.props.refPC[this.props.ind] ? acertou :  noclick : this.props.refPC[this.props.ind] ? acertou : clicked }
               
                onClick={this.reactClick}
               
            >
                {this.props.value}
            </button>
            </div>
        );
    }
}
